export default __webpack_public_path__ + "./fonts/downloadPdf.d2a6dd65.svg";